export const mockBrandProfile = {};
